import http from '../http'

/**
 * 上传文件（通用附件上传接口）
 * @param {FormData} formData - 包含文件的表单数据
 * @param {File} formData.file - 文件（必填）
 * @param {String} formData.category - 文件类别，如：settlement, invoice, order等（必填）
 * @param {Number} formData.relatedId - 关联的业务ID，如结算单ID、发票ID等（必填）
 * @returns {Promise} 返回上传结果的Promise对象，包含文件路径
 */
export function upload_attachment(formData) {
  return http.post('/attachments/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 下载文件（通用附件下载接口）
 * @param {String} filePath - 文件相对路径（从业务表中读取）
 * @param {String} [fileName] - 下载时显示的文件名（可选）
 * @returns {Promise} 返回文件流的Promise对象
 */
export function download_attachment(filePath, fileName) {
  const params = { filePath }
  if (fileName) {
    params.fileName = fileName
  }
  return http.get('/attachments/download', {
    params,
    responseType: 'blob'
  })
}

export default {
  upload_attachment,
  download_attachment
}

